import { EmptyState } from '@/components/common/EmptyState';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import { CreateProjectCard } from '@/components/projects/CreateProjectCard';
import { ProjectCard } from '@/components/projects/ProjectCard';
import type { ProjectListItem } from '@/types/project.types';
import type { FC } from 'react';

interface ProjectGridProps {
  projects: ProjectListItem[];
  isLoading: boolean;
  onProjectClick: (projectId: string) => void;
  onUserClick?: (ownerId: string) => void;
  selectedProjectIds?: Set<string>;
  onProjectSelect?: (projectId: string, selected: boolean) => void;
  onStartUpload?: (file: File) => void;
}

export const ProjectGrid: FC<ProjectGridProps> = ({
  projects,
  isLoading,
  onProjectClick,
  onUserClick,
  selectedProjectIds,
  onProjectSelect,
  onStartUpload,
}) => {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <LoadingSpinner size="large" />
      </div>
    );
  }

  if (projects.length === 0) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <CreateProjectCard onStartUpload={onStartUpload} />
        <div className="md:col-span-2 lg:col-span-2">
          <EmptyState title="No projects yet" message="Create your first project by uploading a .stp file" />
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      <CreateProjectCard onStartUpload={onStartUpload} />
      {projects.map((project) => (
        <ProjectCard
          key={project.id}
          project={project}
          onClick={onProjectClick}
          onUserClick={onUserClick}
          isSelected={selectedProjectIds?.has(project.id) ?? false}
          onSelect={onProjectSelect}
        />
      ))}
    </div>
  );
};
